document.addEventListener('DOMContentLoaded', (event) => {

    function fixUpsellInputs() {
        const container = document.querySelector('[class^="ai-upsell-container"]');
        if (!container) return;
        
        const itemsContainer = container.querySelector('[class^="ai-upsell-items"]');
        let heading = container.querySelector('[class^="ai-upsell-heading"]');

         if (heading && heading.tagName === 'H3') {
            const h2 = document.createElement('h2');
            h2.className = heading.className;
            h2.textContent = heading.textContent;
            heading.replaceWith(h2);
            heading = h2;
        }

        if (itemsContainer) {
            itemsContainer.setAttribute('role', 'group');

            if (heading) {
                heading.id = 'ai-upsell-heading';
                itemsContainer.setAttribute('aria-labelledby', 'ai-upsell-heading');
            }
        }

        container.querySelectorAll('[class^="ai-upsell-item-"]').forEach((item, index) => {
            const input = item.querySelector('input');
            const details = item.querySelector('[class^="ai-upsell-details"]');
            const price = item.querySelector('[class^="ai-upsell-price"]');
            const img = item.querySelector('img');

            const h4 = item.querySelector('h4');
            if (h4) {
                const div = document.createElement('div');
                div.className = h4.className;
                div.textContent = h4.textContent;
                h4.replaceWith(div);
            }
        
            if (input && details && price) {
                details.id = `ai-upsell-details-${index}`;
                price.id = `ai-upsell-price-${index}`;
                input.removeAttribute('aria-label');
                input.setAttribute('aria-labelledby', `${details.id} ${price.id}`);
            }

            if (img) {
                img.setAttribute('alt', '');
                const parent = img.parentElement;
                parent.setAttribute('aria-hidden', 'true');
            }
        });
    }

    fixUpsellInputs();

    function fixComparisonTable() {
        const container = document.querySelector('[class^="ai-comparison-table"]');
        if (!container) return;
        
        const productsList = container.querySelector('[class^="ai-comparison-table"][class*="__products"]');
        if (productsList) {
            productsList.setAttribute('role', 'list');
            
            productsList.querySelectorAll('[class^="ai-comparison-table"][class*="__product-card"]').forEach((card, index) => {
                card.setAttribute('role', 'listitem');

                const detailsList = card.querySelector('[class^="ai-comparison-table"][class*="__product-details"]');
                if (detailsList) {
                    detailsList.setAttribute('role', 'list');
                    
                     detailsList.querySelectorAll('[class^="ai-comparison-table"][class*="__detail-row"]').forEach(row => {
                        row.setAttribute('role', 'listitem');
                    });
                }

                const shopNowButton = card.querySelector('[class^="ai-comparison-table"][class*="__cta-button"]');
                const productName = card.querySelector('[class^="ai-comparison-table"][class*="__product-name"]');
                const productPill = card.querySelector('[class^="ai-comparison-table"][class*="__product-pill"]');

                if (shopNowButton && productName) {
                    productName.id = `ai-comparison-product-name-${index}`;
                    
                    let describedBy = productName.id;
                
                    if (productPill) {
                        productPill.id = `ai-comparison-product-pill-${index}`;
                        describedBy += ` ${productPill.id}`;
                    }
                    
                    shopNowButton.setAttribute('aria-describedby', describedBy);
                
                }

            });       
        }
    }

    fixComparisonTable();
    
})